/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'icomoo/049-folder-open': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" d="M13 15l3-8H3l-3 8zM2 6l-2 9V2h4.5l2 2H13v2z"/>'
  }
})
